import { render, staticRenderFns } from "./SettingsShipping.vue?vue&type=template&id=edd38240&"
import script from "./SettingsShipping.vue?vue&type=script&lang=js&"
export * from "./SettingsShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports